export default "__VITE_ASSET__DdoPz2WD__"